<div class="order-client-details-view">
  <div class="item flex flex__align-items--center"
      *ngFor="let item of items">
    <ng-container *ngIf="item.model">
      <mat-icon *ngIf="item.config.withIcon" color="accent">{{item.config.icon}}</mat-icon>
      <span *ngIf="!item.config.componentConfig"  [ngClass]="{ late: item.config.isLate }">{{item.model}}</span>
      <mat-icon class="tooltip-icon" *ngIf="item.config.withTooltip"
        [matTooltip]="item.config.withTooltip ? item.config.withTooltipText : ''"
        color="warn">
        info
      </mat-icon>
      <app-component-resolver
        *ngIf="item.config.componentConfig" 
        [ngClass]="item.config.classes"
        [data]="item.model"
        [config]="item.config.componentConfig">
      </app-component-resolver>
    </ng-container>
  </div>
</div>